import { useSelector } from "react-redux";

const useSubscriptions = (subscribedServiceRef) => {
  return useSelector((state) => state.subscriptions[subscribedServiceRef]);
};

export default useSubscriptions;
